module.exports = __webpack_public_path__ + "assets/img/sandbox-light.d24ad82e.png";